import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arch_2",
  "use": "icon-arch_2-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"icon-arch_2\"><path d=\"M25.707 55.293l-1.414 1.561 7 7.146h1.414l7-7.146-1.414-1.488L33 60.586V3.414l5.293 5.293 1.414-1.561-7-7.146h-1.414l-7 7.146 1.414 1.488L31 3.414v57.172z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol